import request from '@/utils/request'

export function getAuthor(param) {
    let data = param
    return request({
      url: `/aAuthor/getAuthor`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }

  export function getGroup(param) {
    let data = param
    return request({
      url: `/aAuthor/getGroup`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }


 

 